var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.useSimpleGroups
    ? _c("app-product-group-select-autcomplete", {
        attrs: { value: _vm.value, light: _vm.light, "use-id": "" },
        on: {
          group: function ($event) {
            return _vm.onInputGroup($event)
          },
          subgroup: function ($event) {
            return _vm.onInputSubGroup($event)
          },
        },
      })
    : _c("app-product-group-select-autocomplete-simple", {
        attrs: {
          "main-group:sync": _vm.product.SimpleMainGroup,
          "sub-group:sync": _vm.product.SimpleSubGroup,
          light: _vm.light,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }